import { createContext } from 'react';
import type { AuthSession, Clinic } from '@leoclinic/types';

export interface AuthContextValue {
  useMock: boolean;
  mockSession: AuthSession | null;
  updateMockClinic?: (data: Partial<Clinic>) => void;
}

export const AuthContext = createContext<AuthContextValue>({
  useMock: false,
  mockSession: null,
});
